import fetchBHApi from "@helper/fetchBHApi";
import { BAASResponse, BAASV3Response } from "@typings/MyBH";
import { useCallback, useEffect } from "react";

import { isClientSide } from "../helper/utils";
import useMyBhStore from "../store/useMyBhStore";
import useUserInfo from "./useUserInfo";

/**
 * Hook function to get followed keywords by a user and set them in the store
 */
export default function useGetFollowedTopic() {
  const { userInfo } = useUserInfo();
  const setTags = useMyBhStore((state) => state.setTags);

  const visitorId = userInfo?.visitorId || "";

  const getFollowedTopic = useCallback(async () => {
    const fallback: BAASResponse[] = [];
    try {
      if (visitorId === "") return fallback;

      const response = await fetchBHApi<BAASV3Response>(
        "baasGetFollowedDetails",
        "GET",
        {},
        {
          visitorID: visitorId,
        },
      );

      const tags =
        response.code === 200 && Array.isArray(response.tags)
          ? response.tags
          : fallback;

      setTags(tags);

      return tags;
    } catch (error) {
      setTags(fallback);
      return fallback;
    }
  }, [visitorId, setTags]);

  useEffect(() => {
    if (!isClientSide) return;
    if (!visitorId) return;

    void getFollowedTopic();
  }, [visitorId, getFollowedTopic]);
}
